import classNames from "classnames";
import * as React from "react";

import styles from "./DashboardWrapper.module.scss";

type Props = {
  children: React.ReactNode;
  className?: string;
  style?: Object;
};

export default function DashboardWrapper(props: Props) {
  const { children, className, style } = props;
  return (
    <div className={classNames(styles.wrapper, className)} style={style}>
      {children}
    </div>
  );
}
